<app-card class="header">
  <div>
    <app-ribbon type="idea" />
    <h1 class="title" i18n>Scheduling</h1>
    <p><b i18n>Are you always operating your fields in the most efficient order?</b></p>
    <p i18n>
      With a scheduling tool our aim is to reduce transport and ineffective time with intelligent planning of field
      work. Based on distance between fields, capacity and local weather forecasts, our scheduling mechanism will come
      up with an optimized schedule for the fields you select.
    </p>
  </div>
  <div>
    <div i18n class="subtitle">Have a look</div>
    <p i18n>
      Take a look at the scenario that illustrates how a tool could be used to reduce transport and ineffective time.
    </p>
    <p i18n>
      Examine the example schedule and consider if you would use a tool to support your planning, if it could optimize
      your field work.
    </p>
    <p class="info-feedback">
      <span i18n>... and let us know what you think -</span>
      <app-link i18n target="_self" [href]="goToFeedback()">send your feedback</app-link>
    </p>
  </div>
</app-card>
<app-card>
  <app-card-title i18n-title title="Imagine you could reduce transport and idle time" />
  <app-steps [steps]="steps" />
</app-card>
<app-card class="schedule">
  <app-card-title i18n-title title="Schedule Example" />
  <div class="image-wrapper">
    <img src="images/SCH_example.png" i18n-alt alt="Example" />
  </div>
</app-card>
<app-card id="feedback">
  <app-feedback-card feature="scheduling" />
</app-card>
